import React from 'react';
import { XCircle, ArrowLeft } from 'lucide-react';

const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-8 h-8 text-gray-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h1>
        <p className="text-gray-600 mb-6">
          No worries! Your payment was cancelled and you haven't been charged. You can continue using your free trial or upgrade anytime.
        </p>
        
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6">
          <h3 className="font-semibold text-blue-800 mb-2">Your trial continues:</h3>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• Access to all features during trial</li>
            <li>• No commitment required</li>
            <li>• Upgrade anytime</li>
          </ul>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={() => window.location.href = '/'}
            className="w-full px-6 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors flex items-center justify-center space-x-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back to App</span>
          </button>
          
          <p className="text-xs text-gray-500">
            Questions? Contact us at support@yourapp.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;